import React, { Fragment } from 'react'

import { ProcessEntity, ProcessStatus } from '../Types/entities'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { Chip, Tooltip, Typography } from '@mui/material'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import ScheduleIcon from '@mui/icons-material/Schedule'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { utcToLocal } from '../../../utils/dateHelper'

export const generateTableHeaders = () => {
  const headers: TableHeaderConfigWithType<ProcessEntity>[] = [
    {
      field: 'processId',
      title: 'Nro.',
      sortable: false
    },
    {
      field: 'typeProcessName',
      title: 'Tipo',
      sortable: false
    },
    {
      field: 'fileName',
      title: 'Nombre',
      sortable: false,
      formater: (filename: unknown) => formatFileName(filename as string)
    },
    {
      field: 'userName',
      title: 'Usuario',
      sortable: false
    },
    {
      field: 'statusId',
      title: 'Estado',
      sortable: false,
      formater: (image: unknown) => setStatus(image as unknown)
    },
    {
      field: 'createDate',
      title: 'Fecha Creación',
      sortable: false,
      formater: (createdAt) =>
        createdAt ? utcToLocal(createdAt.toString(), 'dd/MM/yyyy HH:mm:ss') : ''
    },
    {
      field: 'startDate',
      title: 'Fecha Inicio',
      sortable: false,
      formater: (createdAt) =>
        createdAt ? utcToLocal(createdAt.toString(), 'dd/MM/yyyy HH:mm:ss') : ''
    },
    {
      field: 'endDate',
      title: 'Fecha Fin',
      sortable: false,
      formater: (createdAt) =>
        createdAt ? utcToLocal(createdAt.toString(), 'dd/MM/yyyy HH:mm:ss') : ''
    }
  ]

  return headers
}

const setStatus = (id: number | unknown) => {
  let label = ''
  let icon = null
  let color = ''

  switch (id) {
    case ProcessStatus.Created:
      label = 'Creado'
      icon = <PlaylistAddCheckIcon />
      color = '#2196f3'
      break
    case ProcessStatus.InProcess:
      label = 'En Proceso'
      icon = <ScheduleIcon />
      color = '#ffea00'
      break
    case ProcessStatus.Finalized:
      label = 'Finalizado'
      icon = <CheckCircleOutlineIcon />
      color = '#4caf50'
      break
    default:
      label = 'Con Errores'
      icon = <ErrorOutlineIcon />
      color = '#f48fb1'
      break
  }

  return (
    <Fragment>
      <Chip icon={icon} label={label} style={{ backgroundColor: color }} />
    </Fragment>
  )
}

export const downloadBase64File = (
  base64: string,
  fileName: string,
  mimeType: string
) => {
  // Decodifica la cadena base64
  const byteCharacters = atob(base64)
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)

  // Crea un Blob con el tipo MIME correcto
  const blob = new Blob([byteArray], { type: mimeType })

  // Crea un enlace y lo dispara para descargar
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  // Limpieza
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const formatFileName = (fileName: string) => {
  return (
    <Tooltip title={fileName}>
      <Typography
        noWrap
        variant='body2'
        style={{
          maxWidth: 220,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'inline-block',
          verticalAlign: 'middle'
        }}
      >
        {fileName}
      </Typography>
    </Tooltip>
  )
}

export const downloadBase64FileDialog = (
  base64: string,
  fileName: string,
  mimeType: string
) => {
  // Decodifica la cadena base64
  const byteCharacters = atob(base64)
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)

  // Crea un Blob con el tipo MIME correcto
  const blob = new Blob([byteArray], { type: mimeType })

  // Crea un enlace y lo dispara para descargar
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()

  // Limpieza
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
